<template>
  <fragment>
    <h5 class="flex-grow-1">{{ title }}</h5>
    <div class="close-button-container">
      <CloseButton :onClick="onCloseButton" :id="closeButtonId" />
    </div>
  </fragment>
</template>

<script>
import CloseButton from '@components/common/CloseButton.vue'

export default {
  name: 'ModalHeader',
  components: { CloseButton },
  props: {
    title: String,
    onCloseButton: Function,
    closeButtonId: String
  }
}
</script>

<style scoped lang="scss">
.close-button-container {
  margin-top: -7px;
}
</style>
